import { GovernancePortal } from './GovernancePortal';

/** Administrator composition; backend review scope still decides every operation. */
export function AdminApp() {
  return <GovernancePortal />;
}
